import { GamgeeChatMessageRead, ImageInMessage } from "~/types/message";
import { getRequestWithAuth, postRequestWithAuth, getBlobRequestWithAuth } from "../api";


export const initiateChatSession = async (message: string, dataSourceIds: string[], attachments?: File[]) => {
  const formData = new FormData();
  formData.append('message', message);
  formData.append('data_source_ids', JSON.stringify(dataSourceIds));
  if (attachments) {
    attachments.forEach((file) => {
      formData.append('attachments', file);
    });
  }
  const response = await postRequestWithAuth(
    '/api/v1/chat/initiateChatSession',
    formData,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response;
};

export const getAllMessages = async (sessionId: string): Promise<GamgeeChatMessageRead[]> => {
  const response = await getRequestWithAuth(
    `/api/v1/chat/getAllMessages?session_id=${sessionId}`
  );
  return response;
};

export const getMessage = async (messageId: string): Promise<GamgeeChatMessageRead> => {
  const response = await getRequestWithAuth(
    `/api/v1/chat/getMessage?message_id=${messageId}`
  );
  return response;
}


export const sendMessage = async (sessionId: string, message: string, attachments?: File[]) => {
  const formData = new FormData();
  formData.append('session_id', sessionId);
  formData.append('message', message);
  if (attachments) {
    attachments.forEach((file) => {
      formData.append('attachments', file);
    });
  }
  const response = await postRequestWithAuth(
    `/api/v1/chat/sendMessage`,
    formData,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response;
};

export const getMessageImage = async (sessionId: string, messageId: string, imageName: string): Promise<ImageInMessage> => {
  const response = await getBlobRequestWithAuth(
    `/api/v1/chat/getMessageImage?session_id=${sessionId}&message_id=${messageId}&image_name=${imageName}`
  );

  const blob = response.data;
  const reader = new FileReader();
  const dataUrlPromise = new Promise<string>((resolve, reject) => {
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to convert blob to base64 string.'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const dataUrl = await dataUrlPromise;

  return {
    file_name: imageName,
    image_data: dataUrl
  };
};
